<template>
  <div class="connect-field">
    <p>{{$ml.get('This field requires')}} <b>{{area}}</b> {{$ml.get('available hectares')}},</p>
    <p>{{$ml.get('You have ')}} <b>{{($store.getters['user/data'].hectares).toFixed(2)}}</b>.</p>
    <crop-selector />
    <app-btn @click="connectField" :disabled="disabled" :loading="loading">
      {{$ml.get('Start subscription')}}
    </app-btn>
  </div>
</template>

<script>
import API from '@/api'
import * as turf from '@turf/turf'
import { mapGetters } from 'vuex'
import CropSelector from '@/components/satellite/CropSelector'

export default {
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      field: 'satellite/fieldInfo',
      crop: 'satellite/crop',
    }),
    area() {
      let polygon = L.polygon(this.coordinates);
      let area = L.GeometryUtil.geodesicArea(polygon._latlngs[0]) * 0.0001;
      return area.toFixed(2);
    },
    coordinates() {
      let coordinates = this.field.coordinates.map((el) => {
        return [+el.latitude, +el.longitude]
      })
      coordinates[coordinates.length] = coordinates[0];
      return coordinates;
    },
    disabled() {
      if(!this.crop || !this.field) {
        return true
      }
      return false
    }
  },
  methods: {
    connectField() {
      this.loading = true;

        return API.satellite.connectField(this.field.id, this.$store.getters['satellite/crop'], this.area)
          .then(res => {
            this.loading = false;
            console.log(res.data);
            if(res.data.success) {
              this.$store.dispatch('farms/updateData').then(res => {
                this.$store.dispatch('satellite/selectField', this.field.id);
              })
            }
          })
          .catch(err => {
            this.loading = false;
            console.log(err.data);
            this.$router.push({
              path: `/dashboard/satellite/active/purchase?id=${this.field.id}`
            })
          });

    },
  },
  components: {
    CropSelector,
  },
  destroyed() {
    this.$store.dispatch('satellite/setCrop', null);
  },
}
</script>

<style lang="css" scoped>
</style>
